angular.module('data-ng-path-item').constant(
  'ItemTypeEnum',
  Enumeration('ItemTypeEnum', {
    INFO: 'INFO',
    CHOICE: 'CHOICE',
    RANK: 'RANK',
    RANGE: 'RANGE',
    BOOLEANS: 'BOOLEANS'
  })
);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/types/item_type_enum.js